import type { components } from "./generated/api-types";

type FetchImpl = (
  input: string,
  init?: Record<string, unknown>,
) => Promise<{
  ok: boolean;
  status: number;
  json(): Promise<unknown>;
  text(): Promise<string>;
}>;

const fetchImpl: FetchImpl = (globalThis as unknown as { fetch: FetchImpl }).fetch.bind(globalThis);

export type LivenessReport = components["schemas"]["LivenessReport"];
export type ReadinessReport = components["schemas"]["ReadinessReport"];
export type HealthReport = components["schemas"]["HealthReport"];
export type ErrorEnvelope = components["schemas"]["ErrorEnvelope"];

export interface ApiClient {
  getLiveness(): Promise<LivenessReport>;
  getReadiness(): Promise<ReadinessReport>;
  getHealth(token: string): Promise<HealthReport>;
}

export function createApiClient(
  baseUrl: string,
  getToken: () => Promise<string | null>,
): ApiClient {
  async function request<T>(path: string, init?: Record<string, unknown>): Promise<T> {
    const res = await fetchImpl(`${baseUrl}${path}`, init as never);
    if (!res.ok) {
      const body = (await res.json().catch(() => ({}))) as ErrorEnvelope;
      throw body;
    }
    return (await res.json()) as T;
  }

  return {
    getLiveness: () => request<LivenessReport>("/health/live"),
    getReadiness: () => request<ReadinessReport>("/health/ready"),
    getHealth: async () => {
      const token = await getToken();
      if (!token) {
        throw new Error("unauthenticated");
      }
      return request<HealthReport>("/health", {
        headers: { Authorization: `Bearer ${token}` },
      });
    },
  };
}
